<template>
  <ul class="tabsCom">
    <li
      v-for="(v, i) in tabList"
      :key="i"
      :class="activeIndex == i ? 'activeLi' : ''"
      @click="changeActive(i)"
    >
      <p>{{ v.name }}</p>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    tabList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeIndex: 0,
    };
  },
  methods: {
    changeActive(index) {
      this.activeIndex = index;
      this.$emit("getTabsActive", { index });
    },
  },
  created() {
    this.$emit("getTabsActive", { index: this.activeIndex });
  },
};
</script>

<style lang="scss" scoped>
.tabsCom {
  width: 100%;
  height: 100%;
  @include setFlexStart;
  li {
    width: 10%;
    margin-right: 1.6%;
    height: 100%;
    background: #fff;
    border: 2px solid #fff;
    @include setFlexCenter;
    p {
      font-size: 14px;
      font-weight: bold;
    }
  }
  li:hover {
    border-color: #33d8d7;
    color: #28cccb;
  }
  .activeLi {
    background: #28cccb;
    border-color: #28cccb;
    color: #fff !important;
  }
}
</style>
